import { ChatModel } from '@/api/models';

// Reasoning efforts offered by the models that accept one, lowest to highest. Must stay
// within the backend allowlist in core/utils/conversation_request.py.
const REASONING_LEVELS = ['low', 'medium', 'high'];

export const chatModels: ChatModel[] = [
  {
    id: 'gpt6luna',
    default: true,
    folder: '',
    brand: 'OpenAI',
    provider_api_family: 'responses',
    reasoning: 'medium',
    reasoning_levels: REASONING_LEVELS,
    name: 'GPT-6 Luna',
    deployment: 'gpt-6-luna',
    files_allowed: true,
    images_allowed: true
  },
  {
    id: 'gpt61terra',
    default: false,
    folder: '',
    brand: 'OpenAI',
    provider_api_family: 'responses',
    reasoning: 'medium',
    reasoning_levels: REASONING_LEVELS,
    name: 'GPT-6.1 Terra',
    deployment: 'gpt-6.1-terra',
    files_allowed: true,
    images_allowed: true
  },
  {
    id: 'gpt61sol',
    default: false,
    folder: '',
    brand: 'OpenAI',
    provider_api_family: 'responses',
    reasoning: 'medium',
    reasoning_levels: REASONING_LEVELS,
    name: 'GPT-6.1 Sol',
    deployment: 'gpt-6.1-sol',
    files_allowed: true,
    images_allowed: true
  },
  {
    id: 'claudehaiku55',
    default: false,
    folder: 'Anthropic',
    brand: 'Anthropic',
    provider_api_family: 'anthropic',
    reasoning: 'medium',
    reasoning_levels: REASONING_LEVELS,
    name: 'Claude Haiku 5.5',
    deployment: 'claude-haiku-5-5',
    files_allowed: true,
    images_allowed: true
  },
  {
    id: 'claudesonnet55',
    default: false,
    folder: 'Anthropic',
    brand: 'Anthropic',
    provider_api_family: 'anthropic',
    reasoning: 'medium',
    reasoning_levels: REASONING_LEVELS,
    name: 'Claude Sonnet 5.5',
    deployment: 'claude-sonnet-5-5',
    files_allowed: true,
    images_allowed: true
  },
];